/** Canonical `localStorage` keys for persisted app settings */
export const LOCAL_STORAGE_KEYS = {
  /** Selected app theme id (`PageBackgroundPreference` / `APP_THEMES`). */
  pageBackgroundId: 'training-guide.page-background',
  /** Rest coach TTS enabled (`'1'` / `'0'`). */
  sessionCoachAudioEnabled: 'training-guide.session-coach-audio',
  /** OpenAI TTS voice id for rest coach (`nova`, `onyx`, etc.). */
  sessionCoachVoice: 'training-guide.session-coach-voice',
  /** Lavish complimentary coach hype tone (`'1'` / `'0'`). */
  sessionCoachHype: 'training-guide.session-coach-hype',
  /** Flirtatious adult coach compliments (`'1'` / `'0'`). */
  sessionCoachSpicy: 'training-guide.session-coach-spicy',
  /** Last coach picked on start-workout page (id only). */
  lastUsedCoachId: 'training-guide.last-used-coach-id',
  /** Favorited plan program sessions list pages (JSON array). */
  favoriteProgramSessions: 'training-guide.favorite-program-sessions',
  /** Mid-set cheer interval in seconds (`5`, `10`, or `15`). */
  sessionEncourageFrequencySec: 'training-guide.session-encourage-frequency-sec',
} as const;
